import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Config } from "features/config/config.types";

const initialState: Config = {
  locale: "",
  slug: "",
  theme: "light",
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload;
    },
    setSlug: (state, action: PayloadAction<string>) => {
      state.slug = action.payload;
    },
    setTheme: (state, action: PayloadAction<"dark" | "light">) => {
      state.theme = action.payload;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "dark" ? "light" : "dark";
    },
  },
});

export const { setLocale, setSlug, setTheme, toggleTheme } = configSlice.actions;
export const configReducer = configSlice.reducer;
